export default __webpack_public_path__ + "static/media/frequency_gold.81336789.svg";